import {create} from "zustand";
import {devtools} from "zustand/middleware";
import {produce} from "immer";

export type CartItemType = {
    id: number;
    name: string;
    description: string;
    picture: string;
    price: number;
    quantity: number;
}


type ShoppingCartType = {
    isViewShoppingCart: boolean;
    cartItems: CartItemType[];
}

type Action = {
    setViewShoppingCart: (isOpen: boolean) => void;
    addToItem: (goods: CartItemType) => void;
    removeItem: (id: number) => void;
    isInCart: (id: number) => boolean;
    updateQuantity: (id: number, quantity: number) => void;
    resetCart: () => void;
}

export const useShoppingCartStore = create<ShoppingCartType & Action>()(
    devtools(
        (set, get) => ({
            isViewShoppingCart: false,
            cartItems: [],
            setViewShoppingCart: (isOpen: boolean) => {
                set(produce(state => {
                    state.isViewShoppingCart = isOpen;
                }))
            },
            removeItem: (goodsId: number) => set((state) => ({
                cartItems: state.cartItems.filter((item) => item.id !== goodsId),
            })),
            addToItem: (item: CartItemType) => set((state) => ({
                cartItems: [...state.cartItems, item],
            })),
            isInCart: (id) => {
                return get().cartItems.some((item) => item.id === id);
            },
            updateQuantity: (id: number, quantity: number) => set((state) => ({
                cartItems: state.cartItems.map((item) => {
                    if (item.id === id) {
                        return {
                            ...item,
                            quantity: quantity,
                        }
                    }
                    return item;
                }),
            })),
            resetCart: () => set(produce(state => {
                state.cartItems =[];
                state.isViewShoppingCart = false;
            }))

        })
    )
)